<div class="form-group">
    <label class="input-label">{{ 'Question type:' | translate }}</label>
    <select class="form-control background-color-primary"
            name="type" (ngModelChange)="dataChangedEvent($event)"
            [(ngModel)]="fieldOptions.type"
            [disabled]="isDisabled()"
            #type="ngModel">
        <option value="BOOLEAN">{{ 'boolean' | translate }}</option>
        <option value="CLASSIFICATION">{{ 'catalogue' | translate }}</option>
        <option value="SUB_CATALOG">{{ 'sub-catalogue' | translate }}</option>
        <option value="DATE">{{ 'date' | translate }}</option>
        <option value="MONEY">{{ 'money' | translate }}</option>
        <option value="NUMERIC">{{ 'number' | translate }}</option>
        <option value="SELECTION">{{ 'selection' | translate }}</option>
        <option value="TEXT">{{ 'text' | translate }}</option>
    </select>
</div>
